export enum Indicators {
	PregnantWomenWithAtLeastSixConsultations = 1,
	PregnantWomenTestedForSyphilisAndHIV = 2,
	PregnantWomenWithDentalCarePerformed = 3,
	CytopathologicalExamsCoverage = 4,
	PoliomyelitisAndPentavalentVaccinationCoverage = 5,
	HypertensivePeopleWithBloodPressureMeasuredEverySixMonths = 6,
	DiabeticsWithHemoglobinA1cRequested = 7,
}
